// removed by extract-text-webpack-plugin
module.exports = {"loginFormContainer":"LoginForm-loginFormContainer-MAyMi","privacyPolicy":"LoginForm-privacyPolicy-1YtdY","azureAdLogin":"LoginForm-azureAdLogin-1ALq7","methodSeparator":"LoginForm-methodSeparator-12N1S"};


//////////////////
// WEBPACK FOOTER
// ./modules/issFrontend/styles/LoginForm.styl
// module id = ./modules/issFrontend/styles/LoginForm.styl
// module chunks = 1